<template>
  <div class="link-wrap">
    <a
      v-for="item in list"
      :key="item.name"
      :href="item.url"
      class="d-block"
      target="_blank"
    >{{ '《' + item.name + '》' }}</a>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: "1001"
    }
  },
  computed: {
    list() {
      const productExtend = this.$store.getters.getProductExtend(this.code);
      if (productExtend) {
        return productExtend.clauses;
      }
      return [];
    }
  }
};
</script>

